<template>
  <div class="addPerson__wrap" v-show="visible">
    <div style="display: flex; align-items: center">
      <el-button
        style="margin: 20px"
        plain
        icon="el-icon-d-arrow-left"
        @click="toggle(false)"
        >返回</el-button
      >
      <div>日期: {{ info.date }}</div>
    </div>

    <div class="main">
      <div style="text-align: left">
        <el-form ref="elFormDom" inline :model="table.params" size="mini">
          <el-form-item label="工单编号:" prop="order_no">
            <el-input v-model="table.params.order_no" clearable></el-input>
          </el-form-item>
          <el-form-item label="工单状态:" prop="status">
            <el-select v-model="table.params.status" clearable>
              <el-option label="待开工/待指派" :value="2"></el-option>
              <el-option label="待完工" :value="3"></el-option>
              <el-option label="已完工" :value="4"></el-option>
              <el-option label="已完成" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              class="theneBtn"
              type="primary"
              icon="el-icon-search"
              @click="onSearch"
              >查询
            </el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="curTableWrap" ref="main2">
        <el-table
          :data="table.data"
          ref="tableDom"
          :height="600"
          border
          style="width: 100%"
          v-loading="table.loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0)"
          :header-cell-style="{ background: '#f5f5f5' }"
          class="chTable"
        >
          <el-table-column label="序号" type="index" key="0" width="60">
          </el-table-column>
          <el-table-column label="工单编号" prop="order_no" width="180">
            <template slot-scope="{ row }">
              <el-button type="text" @click="getGdDetail(row)">{{ row.order_no }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="工单类型" prop="job_id">
            <template slot-scope="{ row }">
              <span v-if="row.job_id == 0">购买工单</span>
              <span v-else>发布工单</span>
            </template>
          </el-table-column>
          <el-table-column label="工单金额" prop="amount">
            <template slot-scope="{ row }">
              <span>￥{{ row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="区域归属收益" prop="area_agency_amount">
            <template slot-scope="{ row }">
              <span>￥{{ row.area_agency_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="邀请用户收益" prop="user_agency_amount">
            <template slot-scope="{ row }">
              <span>￥{{ row.user_agency_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="邀请师傅收益" prop="agency_amount">
            <template slot-scope="{ row }">
              <span>￥{{ row.agency_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总收益" prop="income">
            <template slot-scope="{ row }">
              <span>￥{{ row.income }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工单状态" prop="status">
            <template slot-scope="{ row }">
              <span v-if="row.job_id == 0">
                {{ { 1: "待支付", 2: "待指派", 3: "待服务",4:'已完成',5:'已取消' }[row.service_stauts] }}
              </span>
              <span v-else>{{
                { 2: "待开工", 3: "待完工", 4: "已完工", 5: "已完成" }[
                  row.status
                ]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工单创建时间" prop="create_time" width="180">
          </el-table-column>
        </el-table>
        <div class="pagination__wrap" style="text-align: right">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="table.params.page"
            :page-size="table.params.count"
            :total="table.total"
            :page-sizes="[10, 20, 50, 100, 150]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <OrderDetail ref="orderDetail" />
    <ServeOrderDetail ref="serveOrderDetail" />
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import OrderDetail from "./OrderDetail.vue";
import ServeOrderDetail from "./ServeOrderDetail.vue";
export default {
  mixins: [mixinTable],
  components: {
    OrderDetail,
    ServeOrderDetail,
  },
  data() {
    return {
      height: 0,
      visible: false,
      info: {},
      table: {
        loading: false,
        params: {
          order_no: "",
          status: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.height = this.$refs.main2.offsetHeight || 500;
      this.getTable();
    },
    getGdDetail(row) {
      if(row.job_id) {
        this.$refs.orderDetail.getDetail(row.id);
      }else {
        this.$refs.serveOrderDetail.getDetail(row.id,row.service_stauts);
      }
    },
    getTable() {
      let _params = {
        ...this.table.params,
        date: this.info.date,
      };
      this.table.loading = true;
      this.$http
        .get("/agency/income/info", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.$nextTick(() => {
              // 	对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              if (this.$refs.tableDom && this.$refs.tableDom.doLayout) {
                this.$refs.tableDom.doLayout();
              }
            });
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    toStr(data, key) {
      return data[key];
    },
  },
};
</script>
<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
  background-color: #fff;
  margin: 10px;
  z-index: 5 !important;
  overflow: scroll;
  .main {
    width: 90%;
    margin: 0 auto;
  }
}
.avatar_img ::v-deep img {
  width: 100%;
  height: 100%;
}
</style>

